// outline blue button

import React from "react";
import { questionSvg } from "./Assets";
export default function QuestionBtn({ children, onClick, size = 20 }) {
  // button with arrow image
  return (
    <button
      onClick={onClick}
      style={{ width: `${size}px`, height: `${size}px` }}
    >
      {children}
      <img src={questionSvg} alt="arrow" />
    </button>
  );
}
